export { default } from './SurfCamsTags';
